module.exports = __webpack_public_path__ + "static/media/figure2.e2a8fd68.jpg";